export var TransactTypes;
(function (TransactTypes) {
    let Network;
    (function (Network) {
        Network["BTC"] = "BTC";
        Network["ERC20"] = "ERC20";
        Network["TRC20"] = "TRC20";
        Network["CELO"] = "CELO";
        Network["SOL"] = "SOL";
        Network["POLYGON"] = "POLYGON";
        Network["CARDANO"] = "CARDANO";
        Network["BASE"] = "BASE";
        Network["TON"] = "TON";
        Network["XRP"] = "XRP";
    })(Network = TransactTypes.Network || (TransactTypes.Network = {}));
    let Tokens;
    (function (Tokens) {
        Tokens["USDC"] = "USDC";
        Tokens["BTC"] = "BTC";
        Tokens["ETH"] = "ETH";
        Tokens["USDT"] = "USDT";
        Tokens["CUSD"] = "CUSD";
        Tokens["SOL"] = "SOL";
        Tokens["XAUT"] = "XAUT";
        Tokens["MATIC"] = "MATIC";
        Tokens["ADA"] = "ADA";
        Tokens["PYUSD"] = "PYUSD";
        Tokens["TON"] = "TON";
        Tokens["RLUSD"] = "RLUSD";
    })(Tokens = TransactTypes.Tokens || (TransactTypes.Tokens = {}));
    TransactTypes.TokenNetworkMapping = {
        [Tokens.USDC]: [
            Network.ERC20,
            Network.CELO,
            Network.BASE,
            Network.SOL,
            Network.POLYGON,
        ],
        [Tokens.BTC]: [Network.BTC],
        [Tokens.ETH]: [Network.ERC20],
        [Tokens.USDT]: [
            Network.TRC20,
            Network.CELO,
            Network.TON,
            Network.SOL,
            Network.POLYGON,
        ],
        [Tokens.CUSD]: [Network.CELO],
        [Tokens.SOL]: [Network.SOL],
        [Tokens.MATIC]: [Network.POLYGON, Network.ERC20],
        [Tokens.XAUT]: [Network.ERC20, Network.TRC20],
        [Tokens.ADA]: [Network.CARDANO],
        [Tokens.PYUSD]: [Network.ERC20],
        [Tokens.TON]: [Network.TON],
        [Tokens.RLUSD]: [Network.XRP],
    };
    let TransactSteps;
    (function (TransactSteps) {
        TransactSteps["BUY_1"] = "BuyHome";
        TransactSteps["BUY_2"] = "PaymentOptions";
        TransactSteps["BUY_3"] = "OrderSummary";
        TransactSteps["CURRENCY_COIN_SELECT"] = "ListCurrencies";
        TransactSteps["CANCEL_TRANSACTION"] = "CancelTransaction";
        TransactSteps["NO_CHANNELS"] = "NoChannels";
    })(TransactSteps = TransactTypes.TransactSteps || (TransactTypes.TransactSteps = {}));
    let TransactionType;
    (function (TransactionType) {
        TransactionType["BUY"] = "buy";
        TransactionType["SELL"] = "sell";
        TransactionType["KYC"] = "kyc";
    })(TransactionType = TransactTypes.TransactionType || (TransactTypes.TransactionType = {}));
    TransactTypes.tokenMinMax = {
        USDT: {
            minTransactionAmount: 10,
            maxTransactionAmount: 10000,
        },
        CUSD: {
            minTransactionAmount: 10,
            maxTransactionAmount: 10000,
        },
        USDC: {
            minTransactionAmount: 10,
            maxTransactionAmount: 10000,
        },
        BTC: {
            minTransactionAmount: 0.0001,
            maxTransactionAmount: 1,
        },
        ETH: {
            minTransactionAmount: 0.001,
            maxTransactionAmount: 10,
        },
        SOL: {
            minTransactionAmount: 0.05,
            maxTransactionAmount: 2.5,
        },
        ADA: {
            minTransactionAmount: 20,
            maxTransactionAmount: 1000,
        },
        XAUT: {
            minTransactionAmount: 0.002,
            maxTransactionAmount: 0.15,
        },
    };
})(TransactTypes || (TransactTypes = {}));
